import { Model } from "pinia-orm";

export default class Document extends Model {
  static entity = "documents";
  static name = "document";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      createdAt: this.attr(null),
      updatedAt: this.attr(null),
      servicesRelatedName: this.attr([]),
      originId: this.attr(null),
      origin: this.attr(null),
      name: this.attr(null),
      source: this.attr(null),
      ref: this.attr(null),
      datetime: this.attr(null),
      version: this.attr(null),
      metaDatas: this.attr({}),
      mimeType: this.attr(null),
      file: this.attr(null),
      documentCustom: this.attr(null),
      filename: this.attr(null),
    };
  }
}
